export interface BankAccountDetails {
  beneficiary: string
  bankName: string
  iban: string
  swift: string
  reference: string
  currency: string
}

/** Demo company receiving account for fiat deposits. */
export const DEPOSIT_BANK: BankAccountDetails = {
  beneficiary: 'Velox Markets Ltd.',
  bankName: 'Example Correspondent Bank',
  iban: 'GB29 NWBK 6016 1331 9268 19',
  swift: 'NWBKGB2L',
  reference: 'VLX-DEP-48291',
  currency: 'USD',
}

export const BANK_CURRENCIES = ['USD', 'EUR', 'GBP'] as const
